<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <ng-container *ngFor="let policy of policyDetails">
    <ng-container *ngIf="policy?.policynumber.policyNumber === policyId">
      <mapfre-card
        [singleCard]="false"
        [additionalSectionClasses]="'box-cardMain'"
        [additionalClasses]="
          'policy-details documents details pl-0 pr-0 documents-w-858 ' +
          policy?.policyType
        "
      >
        <ng-container *ngIf="loadingDocuments">
          <mapfre-loading></mapfre-loading>
        </ng-container>
 
        <ng-container *ngIf="!loadingDocuments">
          <ng-container *ngIf="initialDocumentsData?.length !== 0">
            <section
              class="documents-content details-content mobile-margins"
              [ngClass]="{ 'ma-documents': !isAcmic }"
            >
              <h4 class="mb-4" [ngClass]="{'bn-doc-title-acmic':isAcmic,'bn-doc-title':!isAcmic}">Billing documents</h4>
              <table
                class="documents-table table bn-doc-mb32 custom-document-table"
               
                [ngClass]="{'table-striped-acmic':isAcmic,'margin-bottom mb-0':isAcmic && policy?.policyType !== 'AUTO','table-striped table-striped-ma':!isAcmic}"
                >
                <tbody
               
                >
                  <!-- <tr
                    class="row row-content"
                    *ngIf="
                      policy?.policyFlags?.isEbill == 'ENROLLED' &&
                      policy?.policynumber?.policyNumber.length == 6
                    "
                    (click)="viewEBILL($event)"
                  >
                    <td
                      class="col-auto col-type text-center padding-left pl16"
                      scope="row"
                    ></td>
                    <td class="col col-name no-padding-left">
                      {{ "eBILL" }}
                      <span class="legal disclaimer small font-color">{{
                        "View your bills online"
                      }}</span>
                    </td>
                    <td class="col-auto col-view text-center view-padding">
                      <div class="documents-view-col">
                        <span class="align-top view-copy">{{
                          "ACCESS" | translate
                        }}</span>
                        <i class="material-icons align-top"
                          >keyboard_arrow_right</i
                        >
                      </div>
                    </td>
                  </tr> -->
                  <ng-container *ngIf="documentsData?.length > 0">
                    <ng-container>
                      <tr class="row row-content">
                        <th
                          class="document-table-col-1"
                          [ngClass]="{ 'dm-sans-medium': !isAcmic }"
                        >
                          <div class="acmic-date-col bn-table-header" [ngClass]="{'line-height lh-16':isAcmic}">
                            <div>
                              {{ "Date" | translate }}
                            </div>
                            <img *ngIf="!isAcmic"
                            [src]="upAndDownIconForDocDate"
                            class="cursor-pointer"
                            (click)="toggleAndsortDocumentsByDate()"
                            alt="arrow"
                          />
                            <img *ngIf="isAcmic"
                            [src]="upAndDownIconForDocDateAcmic"
                            class="cursor-pointer"
                            (click)="toggleAndsortDocumentsByDateAcmic()"
                            alt="arrow"
                          />
 
                          </div>
                        </th>
                        <th
                          class="document-table-col-2 mx-441"
                          [ngClass]="{ 'dm-sans-medium': !isAcmic }"
                        >
                          <div class="bn-table-header" [ngClass]="{'line-height lh-16 showin-desktop-acmic':isAcmic, 'showin-desktop':!isAcmic}">
                            <div>
                              {{ "Description" | translate }}
                            </div>
                            <img *ngIf="!isAcmic"
                            [src]="upAndDownIconForDocName"
                            class="cursor-pointer "
                            (click)="toggleAndsortDocumentsByName()"
                            alt="arrow"
                          />
                            <img *ngIf="isAcmic"
                            [src]="upAndDownIconForDocNameAcmic"
                            class="cursor-pointer "
                            (click)="toggleAndsortDocumentsByNameAcmic()"
                            alt="arrow"
                          />
                          </div>
                          <div class="bn-table-header" [ngClass]="{'showin-mobile-acmic':isAcmic, 'showin-mobile':!isAcmic}">
                            <div>
                              {{ "Document name" | translate }}
                            </div>
                            <img *ngIf="!isAcmic"
                              [src]="upAndDownIconForDocName"
                              class="cursor-pointer"
                              (click)="toggleAndsortDocumentsByName()"
                              alt="arrow"
                            />
                            <img *ngIf="isAcmic"
                              [src]="upAndDownIconForDocNameAcmic"
                              class="cursor-pointer"
                              (click)="toggleAndsortDocumentsByNameAcmic()"
                              alt="arrow"
                            />
                          </div>
                        </th>
                        <th class="document-table-col-3"></th>
                        <th class="document-table-col-4"></th>
                      </tr>
                      <tr
                        class="row row-content"
                        *ngFor="let doc of documentsData; index as i"
                        [hidden]="
                          policy.hasAffinityGroup && doc.type === 'AUTOPAY'
                        "
                      >
                        <ng-container *ngIf="!isAcmic; else acmicDocData">
                          <td class="document-table-col-1">
                            {{ doc.transactionDate | date : "MM/dd/yy" }}
                          </td>
                          <ng-container
                            *ngIf="doc?.fileName; else docDescription"
                          >
                            <td class="document-table-col-2 mx-441">
                              {{ doc.fileName }}
                            </td>
                          </ng-container>
                          <ng-template #docDescription>
                            <td class="document-table-col-2 mx-441">
                              {{ doc.description }}
                            </td>
                          </ng-template>
                        </ng-container>
                        <ng-template #acmicDocData>
                          <td class="document-table-col-1" [ngClass]="{'line-height lh-16':isAcmic}">
                            <div class="acmic-doc-val" >
                              {{ doc.transactionDate | date : "MM/dd/yy" }}
                            </div>
                          </td>
                          <td class="document-table-col-2 mx-441" [ngClass]="{'line-height lh-16':isAcmic}">
                            <div class="acmic-doc-val" >
                              {{ doc.fileName }}
                            </div>
                          </td>
                        </ng-template>
                        <td class="document-table-col-3">
                          <span
                            (click)="
                              onViewDocument(
                                doc.documentId,
                                policy?.policynumber.policyNumber,
                                doc.type,
                                doc.transactionDate,
                                doc.description,
                                i+1
                              )
                            "
                          >
                            <span
                              class="doc-action-txt dm-sans-medium cursor-pointer showin-desktop ele-custom-loader view-doc-action-{{i+1}}" [ngClass]="{'doc-action-txt-acmic':isAcmic}"
                              >{{ "View" | translate }}
                            </span>
                            <ng-container *ngIf="isAcmic; else maViewIcon">
                              <img
                                src="assets/img/images/icon-view-blue.svg"
                                class="cursor-pointer ele-custom-loader view-doc-action-{{i+1}}"
                                alt="view icon"
                              />
                            </ng-container>
                            <ng-template #maViewIcon>
                              <img
                                src="assets/img/images/icon-view.svg"
                                class="cursor-pointer showin-desktop ele-custom-loader view-doc-action-{{i+1}}"
                                alt="view icon"
                              />
                              <img
                                src="assets/img/images/icon-view-16.svg"
                                class="cursor-pointer showin-mobile ele-custom-loader view-doc-action-{{i+1}}"
                                alt="view icon"
                              />
                            </ng-template>
                          </span>
                        </td>
                        <td class="document-table-col-4">
                          <span
                            (click)="
                              onDownloadDocument(
                                doc.documentId,
                                policy?.policynumber.policyNumber,
                                doc.type,
                                doc.transactionDate,
                                i+1
                              )
                            "
                          >
                            <span
                              class="dm-sans-medium doc-action-txt cursor-pointer showin-desktop ele-custom-loader download-doc-action-{{i+1}}" [ngClass]="{'doc-action-txt-acmic':isAcmic}"
                              >{{ "Download" | translate }}
                            </span>
                            <ng-container *ngIf="isAcmic; else maDownloadIcon">
                              <img
                                src="assets/img/images/icon-download-acmic-blue.svg"
                                class="cursor-pointer ele-custom-loader download-doc-action-{{i+1}}"
                                alt="download icon"
                              />
                            </ng-container>
                            <ng-template #maDownloadIcon>
                              <img
                                src="assets/img/images/icon-download-red.svg"
                                class="cursor-pointer showin-desktop ele-custom-loader download-doc-action-{{i+1}}"
                                alt="download icon"
                              />
                              <img
                                src="assets/img/images/icon-download-16.svg"
                                class="cursor-pointer showin-mobile ele-custom-loader download-doc-action-{{i+1}}"
                                alt="download icon"
                              />
                            </ng-template>
                          </span>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </section>
          </ng-container>
          <ng-container *ngIf="documentsData?.length === 0">
            <section class="details-content documents-content no-documents">
              <div class="no-documents-container">
                <ng-container *ngIf="false">
                  <div class="row mapfre-card-download-button">
                    <div class="col col-left">
                      <img
                        src="/assets/img/images/mapfre-card-logo-color.png"
                        width="177"
                        alt="card logo"
                      />
                    </div>
                    <div class="col col-right"></div>
                  </div>
                </ng-container>
                <div class="row">
                  <div class="col">
                    <img
                      src="./assets/img/images/no-documents.png"
                      alt="no documents"
                    />
                    <h1 class="title margin-vertical mv16">
                      {{ "NO_DOCUMENTS_TITLE" | translate }}
                    </h1>
                    <p>{{ "NO_DOCUMENTS_PARAGRAPH" | translate }}</p>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>
        </ng-container>
        <section class="row"
          [ngClass]="{ 'ma-legal-links': !isAcmic, 'acmic-legal-links':isAcmic }">
          <div class="col-12 col-md-12 text-left ">
            <ng-container *ngIf="isAcmic; else MAstate">
              <ng-container
                *ngIf="policy?.jurisdiction.state === 'WA'; else IDstate"
              >
              <div class="text-left" *ngIf="company !== 'ACIC' && company !== 'TW'">
                <h4 class="bn-doc-title-other mb-2" [hidden]="policy?.policyType !== 'AUTO'" [ngClass]="{'bn-doc-title-other-acmic':isAcmic}">Other documents</h4>
                <hr class="no-margin-bottom no-margin-top" [hidden]="policy?.policyType !== 'AUTO'" [ngClass]="{'margin-bottom mb24':isAcmic}"/>
              </div>
                <a
                  [hidden]="policy?.policyType !== 'AUTO'"
                  class="mapfre link normal-link blue-link underlineBQ MAIP-link line-height lh-16"
                  href="./assets/docs/AC001-AMWA-02-23-WA-ACMIC.pdf"
                  target="_blank"
                  rel="noopener"
                >
                  {{ "AUTO_INSURANCE_POLICY" | translate }}
                </a>
              </ng-container>
              <ng-template #IDstate>
                <div class="text-left" *ngIf="company !== 'ACIC' && company !== 'TW'">
                  <h4 class="bn-doc-title-other mb-2" [ngClass]="{'bn-doc-title-other-acmic':isAcmic}">Other documents</h4>
                  <hr class="no-margin-bottom no-margin-top" [ngClass]="{'margin-bottom mb24':isAcmic}"/>
                </div>
                <a
                  [hidden]="policy?.policyType !== 'AUTO'"
                  class="mapfre link normal-link blue-link underlineBQ MAIP-link"
                  href="./assets/docs/AC001-AMID-02-23-ID-ACMIC.pdf"
                  target="_blank"
                  rel="noopener"
                >
                  {{ "AUTO_INSURANCE_POLICY" | translate }}
                </a>
              </ng-template>
            </ng-container>
            <ng-template #MAstate>
              <div class="text-left" *ngIf="company !== 'ACIC' && company !== 'TW'">
                <h4 class="bn-doc-title-other mb-2" [ngClass]="{'bn-doc-title-other-acmic':isAcmic}">Other documents</h4>
                <hr class="no-margin-bottom no-margin-top" [ngClass]="{'margin-bottom mb24':isAcmic}"/>
              </div>
              <div class="" [ngClass]="{'padding-top pt12':policy?.policyType === 'AUTO' && company !== 'ACIC' && company !== 'TW'}">
              <a
                [hidden]="policy?.policyType !== 'AUTO'"
                class="mapfre link normal-link grey-color underlineBQ MAIP-link"
                href="./assets/public/docs/MA%20AUTO%20POLICY%202016.pdf#zoom=100"
                target="_blank"
                rel="noopener"
                *ngIf="company !== 'ACIC' && company !== 'TW'"
              >
                {{ "MA_AUTO_INSURANCE_POLICY" | translate }}
              </a>
            </div>
            <div class="col-12 col-md-12 text-left padding-top pt12 padding-left pl-0 padding-right pr-0 margin-bottom mb8" *ngIf="company !== 'ACIC' && company !== 'TW'">
              <a
                class="mapfre link normal-link grey-color underlineBQ line-height lh-18"
                href="https://www.mass.gov/files/documents/2016/07/rk/ways-to-save.pdf#zoom=100"
                target="_blank"
                rel="noopener">
                {{ "WAYS_TO_SAVE" | translate }}
              </a>
            </div>
            </ng-template>
          </div>
        </section>
      </mapfre-card>
    </ng-container>
  </ng-container>
</ng-container>
 